import React, { ReactNode, useEffect } from 'react';

import { datadogRum } from '@datadog/browser-rum';
import { useLocation } from 'react-router-dom';

import { uiRoutes } from '@consumer-frontend/nc-api';
import { mergeClassNameStrings } from '@consumer-frontend/nc-utils';
import { Container } from '@consumer-frontend/shared-ui';

import { NcError } from '../NcError';

import '@consumer-bootstrap/brands/netcredit/error-page.scss';

export type NcErrorPagePropsT = {
  message: ReactNode;
  children?: ReactNode;
  displaySupportText?: boolean;
  fullWidth?: boolean;
  heading?: ReactNode;
};
export type NcErrorPageT = React.FC<NcErrorPagePropsT>;

export const NcErrorPage: NcErrorPageT = ({
  children,
  displaySupportText,
  fullWidth,
  heading,
  message,
}) => {
  const location = useLocation();

  // Scroll to top on mount and log to DD_RUM
  useEffect(() => {
    if (location.pathname === uiRoutes.dashboard.paymentError) {
      datadogRum.addAction('NcMakeAPaymentErrorView');
    }

    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <Container className="nc-error-page" hasBoxShadow>
      {heading && <h1 className="h2">{heading}</h1>}

      <Container className="d-flex align-items-center justify-content-center flex-column">
        <NcError
          displaySupportText={displaySupportText}
          message={message}
          className={mergeClassNameStrings(fullWidth && 'w-100')}
        />
        {children}
      </Container>
    </Container>
  );
};
